import { BotId } from "../../global/models/models";

export interface MatomoFeedback {
    botId: BotId | undefined; // check
    bubbleId: string;
    rating: string;
}

export interface MatomoData {
    seite: {
        eventBotId: BotId | undefined; // check
        bubbleId: string;
        eventValue: string; // Erfasster Datensatz
        eventCategory: string; // Auslöse Art (BTN e.g.)
        eventAction: string; // Event Typ (Close, Error, e.g.)
        eventName: string; // Event Name entsprechend der BTN
    }
    event: string; // Track + EventName
}

export type Rating = 1 | 0 | -1;

declare global {
    interface Window {
        _mtm: any;
    }
}

// data-analytics* an Klickbaren Elementen
/*
    eventAction: matomo.seite.eventAction,
    eventBotId: matomo.seite.eventBotId,
    eventCategory: matomo.seite.eventCategory,
    eventName: matomo.seite.eventName,
    eventValue: matomo.seite.eventValue,

    data-analytics-track="true"
    data-analytics-action="klick"
    data-analytics-value=" "
    data-analytics-name="TCB: https://www.arbeitsagentur.de/jobsuche"
    data-analytics-category="link"
*/

export const matomo = (matomo: MatomoData) => {
    // console.log(matomo.event, matomo)
    const matomoLoadedByHostSite = Boolean(window._mtm);
    if (matomoLoadedByHostSite) {
        window._mtm.push({
            seite: {
                bubbleId: matomo.seite.bubbleId,
                eventAction: matomo.seite.eventAction,
                eventBotId: matomo.seite.eventBotId,
                eventCategory: matomo.seite.eventCategory,
                eventName: matomo.seite.eventName,
                eventValue: matomo.seite.eventValue,
            },
            event: matomo.event,
        })
    }
}
